export const GHOST_MODE_TYPE_MERCHANT_USER = 'merchant-user';
export const GHOST_MODE_TYPE_MERCHANT = 'merchant';
